import { ICustomerDeliveryAddress, IResponse, IShippingQuote } from "../common/interfaces";
import { request } from "./AjaxService";

const baseRoute = "customer/delivery-address";

export const DeliveryAddressService = {
  getByCustomer: async (
    customerId: number
  ): Promise<IResponse<ICustomerDeliveryAddress[]>> =>
    await request.get(`${baseRoute}/get`, { customerId: String(customerId) }),

  create: async (payload: {
    name: string;
    address: string;
    number?: string;
    lat?: number;
    lng?: number;
    customer_id: number;
  }): Promise<IResponse<ICustomerDeliveryAddress>> =>
    await request.post(baseRoute, payload),

  /** Cotización de envío desde una sucursal; mismo cálculo que chatbot y app (backend). */
  quoteShipping: async (payload: {
    warehouse_id: number;
    delivery_address_id?: number;
    lat?: number;
    lng?: number;
    order_total?: number;
  }): Promise<{ status: boolean; message: string; data: IShippingQuote | null }> =>
    await request.post("shipping/quote", payload),
};
